import React, { useState, useRef } from "react";
import * as Yup from "yup";
import {
  Form as BaseForm,
  DisableTextField,
  TextAreaField,
  SubmitButton,
  CancelPopupButton,
} from "../../ui/FormElement";
import { useClaimContext } from "../../contexts/ClaimContext";

export default function EditForm({ closeForm, row }) {
  let FormSchema = Yup.object().shape({
    reason: Yup.string().required("Details are required"),
  });

  const { dispatch, state, actions } = useClaimContext();

  let [loader, setLoader] = useState(false);

  const [formData, setFormData] = useState({
    reason: row.attributes.body,
  });

  const formSendSuccess = () => {
    swal({
      title: "Claim Updated!",
      text: "Our claim's specialist will reach out to you shortly.",
      html: true,
      type: "success",
      showCancelButton: false,
      confirmButtonText: "Close",
      closeOnConfirm: true,
    });
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);
    actions.updateClaim(dispatch, row.id, values, () => {
      setLoader(false);
      closeForm();
      formSendSuccess();
      actions.loadClaims(dispatch);
    });
  };

  return (
    <BaseForm
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      <div>
        <DisableTextField label="Member*" value={row.attributes.member} />
      </div>
      <div>
        <DisableTextField
          label="Program*"
          value={row.attributes.program.title}
        />
      </div>
      <div>
        <DisableTextField
          label="Completed*"
          value={row.attributes.program.last_session_completed_date}
        />
      </div>
      <div>
        <DisableTextField
          label="Claim Type*"
          value={row.attributes.claim_type}
        />
      </div>
      <div>
        <TextAreaField
          name="reason"
          label={
            <>
              <span>Details</span>
              <abbr title="required">*</abbr>
            </>
          }
        />
      </div>

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          title="Cancel"
          onClick={closeForm}
        />
        <SubmitButton
          title={loader ? "Please, wait ..." : "Send"}
          className={`btn width-120 btn-primary submit-button mr5 ml5 ${
            loader ? "not-possible-click" : ""
          }`}
        />
      </div>
    </BaseForm>
  );
}
